import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Api from "Api/Api";
import Auth from "Api/Auth";
import InvestorView from "components/AdminComponents/InvestorView";

export default function Profile() {
  const dispatch = useDispatch();
  const [investorDetails, setInvestorDetails] = useState({});

  const getInvestorDetail = async () => {
    const response = await Api.getUserDetails(Auth.decodedToken().investorId);
    if (response.status === 200) {
      setInvestorDetails(response.data);
    }
  };
  useEffect(() => {
    getInvestorDetail();
    dispatch({
      type: "SectionSelected",
      payload: "Profile",
    });
  }, []);
  return (
    <>
      {Object.keys(investorDetails).length && (
        <InvestorView investor={investorDetails} />
      )}
    </>
  );
}
